angular.module('gym.invoices').factory('BulkInvoices', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('invoices_collection');
}]);
